import { Modal } from '@carbon/react';
import { useTranslation } from '@pos/i18n';
import type { ReactNode } from 'react';

export interface ConfirmDialogProps {
  open: boolean;
  title: string;
  /** Repeats the action, e.g. "Void order"; never "OK" (§8.2). */
  confirmLabel: string;
  danger?: boolean;
  busy?: boolean;
  onConfirm(): void;
  onCancel(): void;
  children?: ReactNode;
}

/** Only for irreversible actions: void order, refund, close the day (§9.3). */
export function ConfirmDialog({ open, title, confirmLabel, danger = true, busy, onConfirm, onCancel, children }: ConfirmDialogProps) {
  const { t } = useTranslation();
  return (
    <Modal
      open={open}
      danger={danger}
      size="sm"
      preventCloseOnClickOutside
      modalHeading={title}
      primaryButtonText={confirmLabel}
      primaryButtonDisabled={busy}
      secondaryButtonText={t('common.cancel')}
      closeButtonLabel={t('carbon.close')}
      onRequestSubmit={onConfirm}
      onRequestClose={onCancel}
    >
      {children}
    </Modal>
  );
}
